import Checkbox from "@mui/material/Checkbox";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Layer } from "~ui-components/types/__generated/gql/graphql";

export interface LayerContextMenuProps {
	anchorEl?: HTMLElement | null;
	onClose?: () => void;
	open?: boolean;
	onDelete: () => void;
	onLayerVisibilityChange: (id: string, visible: boolean) => void;
	currentLayer?: Layer;
}

export function LayerContextMenu({
	currentLayer,
	anchorEl,
	onClose,
	open = false,
	onDelete,
	onLayerVisibilityChange,
}: LayerContextMenuProps) {
	return (
		<Menu
			anchorEl={anchorEl}
			anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
			onClose={onClose}
			open={open}
			transformOrigin={{ horizontal: "right", vertical: "top" }}>
			<MenuItem
				onClick={() => {
					if (currentLayer)
						onLayerVisibilityChange?.(currentLayer.id, !currentLayer.visible);
				}}>
				<Checkbox checked={currentLayer?.visible ?? false} />
				Change layer visibility
			</MenuItem>
			<MenuItem
				onClick={onDelete}
				sx={{ color: "var(--mui-palette-error-main)" }}>
				Delete layer
			</MenuItem>
		</Menu>
	);
}
